<section class="section section-shaped">
  <div class="container">
    <div class="row">
      <h3 class="col-12 text-center font-weight-extrabold">
        {{ 'mysec.teamMember' | translate }}
      </h3>
    </div>
    <div class="row justify-content-center mt-3">
      <div class="col-lg-8">
        <form [formGroup]="form" [class.show-form-error]="showFormError">
          <div class="mb-4">
            @if (!isLoading) {
              <div class="input-field">
                <div
                  class="profile-upload"
                  agmoUploader
                  [accept]="accept"
                  (selectFiles)="selectFile($event)"
                >
                  @if (!profileImage) {
                    <div class="profile-image pitchin-icon-profile"></div>
                  }
                  @if (profileImage) {
                    <img class="profile-image" [src]="profileImage" />
                  }
                  <div class="pitchin-icon pitchin-icon-add"></div>
                </div>
              </div>
            }
            @if (!profileImage) {
              <div class="text-primary text-center pt-3">
                {{ 'common.dragAndDropImage' | translate }}
              </div>
            }
            @if (profileImage) {
              <div class="text-primary text-center pt-3">
                {{ 'common.lookingGood' | translate }}
              </div>
            }
            @if (isLoading) {
              <agmo-loading></agmo-loading>
            }
          </div>
          <div class="form-group">
            <label class="input-label"> {{ 'mysec.fullNameAsPerIC' | translate }}* </label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'signUp.fullNamePlaceholder' | translate }}"
              formControlName="name"
              maxLength="200"
            />
          </div>
          <div class="form-group">
            <label class="input-label"> {{ 'mysec.position' | translate }}* </label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'mysec.positionPlaceholder' | translate }}"
              formControlName="position"
              maxLength="200"
            />
          </div>
          <div class="form-group">
            <label class="input-label">{{ 'mysec.aboutYourTeamMember' | translate }}</label>
            <textarea
              class="form-control"
              cols="30"
              rows="5"
              formControlName="details"
              placeholder="{{ 'mysec.aboutPlaceholder' | translate }}"
              maxLength="500"
            ></textarea>
          </div>
          <div class="d-flex justify-content-center mt-5">
            <button class="btn btn-primary" (click)="submit()">
              {{ 'common.submit' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
